const IS_STANDALONE = window.matchMedia('(display-mode: standalone)').matches;
export default IS_STANDALONE;
